export default {
  showWidget: false,
  form: {
    searchtext: '',
    news: false,
    colors: [],
    material: null,
    productgroupid: null
  }
}